import {
  compareThreadIdentifiers,
  convertMessageToShipperInboxItem,
  type MessageUpdateEvent,
} from '@fv/models'

import { useCurrentUser } from '@/hooks/settings/useAppContext'

import { useHasPermission, useRole } from '../auth/hooks'
import {
  useUnreadCountCacheInvalidator,
  useUpdateMessagesInInboxCache,
  useUpdateMessagesInLoadCache,
} from './cache-modifiers'

export const useMessagesLiveEventsHandler = () => {
  const inboxModifier = useUpdateMessagesInInboxCache()
  const loadMessagesModifier = useUpdateMessagesInLoadCache()
  const invalidateUnreadCount = useUnreadCountCacheInvalidator(1000)
  const user = useCurrentUser()

  return (event: MessageUpdateEvent) => {
    const { loadId, message } = event.data
    const item = convertMessageToShipperInboxItem(user._id, message)
    loadMessagesModifier(loadId, messages => [
      message,
      ...messages.filter(m => m._id !== message._id),
    ])
    if (message.participants.find(p => p.id === user._id && !p.isAuthor)) {
      inboxModifier(threads =>
        threads.map(t =>
          compareThreadIdentifiers(t.identifier, item.identifier) ? item : t,
        ),
      )
    }
    invalidateUnreadCount()
  }
}

export const canAccessMessages = () => {
  const role = useRole()
  const canQuote = useHasPermission('load-creator')
  return role === 'shipper' && canQuote
}
